var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, DataTable, IconButton, Page } from '@dixa/lib-shared-habla';
import { client as elevioClient } from 'elevio';
import FileSaver from 'file-saver';
import { conversationsApi } from 'apis/conversations';
import { userContentApi } from 'apis/userContent';
import { appActions } from 'app/app.actions';
import { AppLink } from 'components/appLink';
import { channelAttributes } from 'utils/channels';
import { articles } from 'utils/elevio';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { ScheduledConversationsBanner } from '../banner/scheduledConversationsBanner';
import { ScheduledConversationsModal } from '../modal/scheduledConversationsModal';
export const ScheduledConversationsTable = () => {
    const dispatch = useAppDispatch();
    const { batches, isLoading, isSuccess, isError, refetch } = conversationsApi.useReadScheduledConversationBatchesQuery(undefined, {
        selectFromResult: (_a) => {
            var _b;
            var { data } = _a, rest = __rest(_a, ["data"]);
            return (Object.assign(Object.assign({}, rest), { batches: (_b = data === null || data === void 0 ? void 0 : data.data.batches) !== null && _b !== void 0 ? _b : [] }));
        },
    });
    const [readScheduledConversationsCsv] = userContentApi.useLazyReadScheduledConversationsCsvQuery();
    const handleDownload = (path) => __awaiter(void 0, void 0, void 0, function* () {
        const text = yield readScheduledConversationsCsv({ path }).unwrap();
        const file = new File([text], `${path.split('/').pop()}.csv`, {
            type: 'text/csv;charset=utf-8',
        });
        FileSaver.saveAs(file);
    });
    const handleImport = () => {
        dispatch(appActions.showModal({
            modal: {
                type: 'settings:scheduledConversations',
            },
        }));
    };
    const table = (_jsx(DataTable, { data: batches, columns: [
            {
                label: 'Schedule name',
                selector: (item) => item.name,
            },
            {
                label: 'Queue',
                selector: (item) => (_jsx(AppLink, Object.assign({ path: "/conversations", params: {
                        search: {
                            queue: [item.queue_id],
                            channel: [item.channel],
                        },
                    } }, { children: item.queue_name }))),
            },
            {
                label: 'Channel',
                selector: (item) => channelAttributes[item.channel].name,
            },
            {
                label: '',
                selector: (item) => (_jsx(IconButton, { icon: "download", variant: "tertiary", onClick: () => handleDownload(item.csv_url) })),
                style: {
                    width: 0,
                },
            },
        ], tableStatusProps: {
            loading: isLoading,
            loadingFailed: isError,
            onLoadingRetry: refetch,
            emptyState: !batches.length && isSuccess
                ? {
                    title: 'No scheduled conversations',
                    description: 'Click on "Import .csv" above to get started with scheduling conversations.',
                    buttonProps: {
                        variant: 'secondary',
                        children: 'Read documentation',
                        onClick: () => elevioClient.openArticle(articles.settings.scheduledConversations.documentation),
                    },
                }
                : undefined,
        } }));
    return (_jsxs(_Fragment, { children: [_jsx(Page.Section, Object.assign({ title: "All scheduled conversations", controls: _jsx(Button, Object.assign({ variant: "primary", onClick: handleImport }, { children: "Import .csv" })), callout: _jsx(ScheduledConversationsBanner, {}) }, { children: table })), _jsx(ScheduledConversationsModal, {})] }));
};
